import { IField } from '@eventr/common'
import { Typography } from '@eventr/common-storybook'
import { FormControlLabel, FormLabel, Switch } from '@mui/material'
import i18n from '../../../i18n/i18next'
import { useEditSectionContext } from '../editSectionProvider'

interface ISwitchEditFieldProps {
    field: IField
    _id?: string
}

export const SwitchEditField = ({ field, _id }: ISwitchEditFieldProps) => {
    const { getValue } = useEditSectionContext()
    const { updateValues } = useEditSectionContext()

    const onChange = (e: any) => {
        updateValues({
            value: e.target.checked,
            field: field,
            _id: _id,
        })
    }

    /// This is to fix the React render issue, "This may be an issues with react, please report."
    const getValueSafe = (): boolean => {
        if (getValue(field, _id) === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <FormControlLabel
            sx={{
                flexDirection: 'row-reverse',
                justifyContent: 'flex-end',
                marginLeft: '0px',
            }}
            labelPlacement="top"
            control={<Switch checked={getValueSafe()} onChange={onChange} />}
            label={
                <FormLabel>
                    <Typography variant="bodyRegular">
                        {i18n.t(`edit-itinerary.fields.${field.id}`)}
                    </Typography>
                </FormLabel>
            }
        />
    )
}
